import Image from "next/image";

type IGImageProps = {
  size?: number;
};
export const IGImage = ({ size = 16 }: IGImageProps) => {
  return (
    <Image
      height={size}
      width={size}
      src="/images/ig.png"
      alt="ig"
      className="object-cover"
    />
  );
};
